<div class="row" *ngIf="user">
  <div class="col-lg-12">
    <div class="grid">
      <p class="grid-header split-header">
				<span>Edit User Profile</span>
        <button type="button" class="btn btn-primary" (click)="downloadConfig($event)"><i class="mdi mdi-download"></i> VPN Config</button>
			</p>
      <div class="grid-body">
        <div class="item-wrapper">
          <form (ngSubmit)="submitForm()" #userForm="ngForm">
            <div class="form-group">
              <label for="first_name">First Name</label>
              <input [(ngModel)]="user.firstName" #firstName="ngModel" name="first_name" type="text" class="form-control" [ngClass]="{'is-invalid': firstName.invalid && (firstName.dirty || firstName.touched)}" required/>
              <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" class="invalid-feedback">
                <p *ngIf="firstName.errors?.required">
                  First Name is required.
                </p>
              </div>
            </div>
            <div class="form-group">
              <label for="last_name">Last Name</label>
              <input [(ngModel)]="user.lastName" #lastName="ngModel" name="last_name" type="text" class="form-control" [ngClass]="{'is-invalid': lastName.invalid && (lastName.dirty || lastName.touched)}" required/>
              <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="invalid-feedback">
                <p *ngIf="lastName.errors?.required">
                  Last Name is required.
                </p>
              </div>
            </div>
            <div class="form-group">
              <label for="username">User Name</label>
              <input [(ngModel)]="user.username" #username="ngModel" name="username" type="text" class="form-control" [ngClass]="{'is-invalid': username.invalid && (username.dirty || username.touched)}" required/>
              <div *ngIf="username.invalid && (username.dirty || username.touched)" class="invalid-feedback">
                <p *ngIf="username.errors?.required">
                  Username is required.
                </p>
              </div>
            </div>
            <div class="form-group">
              <label for="email">Email Address</label>
              <input [(ngModel)]="user.email" #email="ngModel" name="email" type="email" class="form-control" [ngClass]="{'is-invalid': email.invalid && (email.dirty || email.touched)}" required email/>
              <div *ngIf="email.invalid && (email.dirty || email.touched)" class="invalid-feedback">
                <p *ngIf="email.errors?.required">
                  Email is required.
                </p>
                <p *ngIf="email.errors?.email">
                  Must be a valid email address.
                </p>
              </div>
            </div>
            <div class="form-group">
              <label for="gl_ip">VPN Device IP</label>
              <input [(ngModel)]="user.gl_ip" #gl_ip="ngModel" name="gl_ip" type="text" class="form-control" [ngClass]="{'is-invalid': gl_ip.invalid && (gl_ip.dirty || gl_ip.touched)}" pattern="\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b"/>
              <div *ngIf="gl_ip.invalid && (gl_ip.dirty || gl_ip.touched)" class="invalid-feedback">
                <p *ngIf="gl_ip.errors?.pattern">
                  Must be a valid IP address.
                </p>
              </div>
            </div>
            <div class="form-group">
              <button class="btn btn-primary" (click)="changePasswordState = true" *ngIf="!changePasswordState">Change Password</button>
            </div>
            <div *ngIf="changePasswordState" ngModelGroup="passwords" #passwords="ngModelGroup" appCheckPassword>
              <div class="form-group">
                <label for="password">Password</label>
                <input [(ngModel)]="user.password" #password="ngModel" name="password" type="password" class="form-control" [ngClass]="{'is-invalid': passwords.invalid && (password.dirty || password.touched)}"/>
                <div *ngIf="passwords.invalid && (password.dirty || password.touched)" class="invalid-feedback">
                  <p *ngIf="passwords.errors?.passwordStrength">
                    Password must be more complex.
                  </p>
                </div>
              </div>
              <div class="form-group">
                <label for="password_confirm">Confirm Password</label>
                <input [(ngModel)]="password_confirm" #password_conf="ngModel" name="password_confirm" type="password" class="form-control" [ngClass]="{'is-invalid': passwords.invalid && (password_conf.dirty || password_conf.touched)}"/>
                <div *ngIf="passwords.invalid && (password_conf.dirty || password_conf.touched)" class="invalid-feedback">
                  <p *ngIf="passwords.errors?.passwordsMatch">
                    Passwords must match.
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-sm btn-primary" [disabled]="!userForm.form.valid">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
